const COLORS = {
  "Pending Approval": "bg-amber-100 text-amber-800 border-amber-200",
  Booked: "bg-slate-100 text-slate-800 border-slate-200",
  "Picked Up": "bg-sky-100 text-sky-800 border-sky-200",
  "In Transit": "bg-blue-100 text-blue-800 border-blue-200",
  "Arrived at Hub": "bg-indigo-100 text-indigo-800 border-indigo-200",
  "Customs Clearance": "bg-violet-100 text-violet-800 border-violet-200",
  "Out for Delivery": "bg-orange-100 text-orange-800 border-orange-200",
  Delivered: "bg-emerald-100 text-emerald-800 border-emerald-200",
  "On Hold": "bg-yellow-100 text-yellow-900 border-yellow-300",
  Cancelled: "bg-red-100 text-red-800 border-red-200",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center px-2.5 py-1 text-xs font-semibold border rounded-sm whitespace-nowrap ${COLORS[status] || COLORS.Booked}`}>
    {status}
  </span>
);
